var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import PropTypes from 'prop-types';

var List = function (_React$Component) {
  _inherits(List, _React$Component);

  function List() {
    _classCallCheck(this, List);

    return _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).apply(this, arguments));
  }

  _createClass(List, [{
    key: 'render',
    value: function render() {
      var tagName = 'ul';
      var className = 'cf-list';

      if (this.props.ordered) {
        tagName = 'ol';
        className += ' cf-list--ordered';
      }

      if (this.props.unstyled) {
        className += ' cf-list--unstyled';
      }

      return React.createElement(tagName, { className: className }, this.props.children);
    }
  }]);

  return List;
}(React.Component);

List.propTypes = {
  ordered: PropTypes.bool,
  unstyled: PropTypes.bool,
  children: PropTypes.node
};

List.defaultProps = {
  ordered: false,
  unstyled: false
};

export default List;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-list/es/List.js
// module id = 986
// module chunks = 0